<div class="flex flex-row place-content-center items-start">
  <div class="flex flex-col w-full max-w-screen-2xl pt-5">
    <h1 class="text-white mb-6 pl-8">Design From {{source}}</h1>
    <div class="flex flex-row">

      <div class="w-1/3 flex flex-row place-content-center items-center">
        <div class="flex flex-col rounded-lg overflow-hidden w-full max-w-xs bg-white shadow-2xl">
          <img *ngIf="sourceTemplate?.id;else scratch" class="h-auto w-full"
            [src]="sourceTemplate.languageDefinitionMap[sourceTemplateSelectedLanguage].previewImageUrl">
          <ng-template #scratch>
            <div class="h-96 w-80 object-cover max-h-96 flex flex-row place-content-center items-center">
              <mat-icon style="font-size:70px;color:#81848a;height:70px;width:70px;">create</mat-icon>
            </div>

          </ng-template>
          <mat-divider></mat-divider>
          <div class="flex flex-col p-4">
            <div class="flex flex-row place-content-between items-center mb-1.5">
              <h3 class="flex-grow font-bold m-0 h-7 text-black"
                style="text-decoration:underline; text-decoration-style: double;text-decoration-color: rgb(1,90,156);">
                {{templateForm.get('name').value}}</h3>
            </div>
            <span class="text-grey-600 h-5">{{templateForm.get('description').value}}</span>
          </div>
        </div>
      </div>

      <div class="flex-1">
        <form class="flex flex-col p-6" [formGroup]="templateForm">
          <mat-form-field appearance="outline" class="text-white text-xl">
            <mat-label class="text-white">Name</mat-label>
            <input matInput name="name" formControlName="name" autocomplete="off">
          </mat-form-field>
          <mat-form-field appearance="outline" class="text-white text-lg">
            <mat-label class="text-white">Subject</mat-label>
            <input matInput name="subject" formControlName="subject" autocomplete="off">
          </mat-form-field>
          <mat-form-field appearance="outline" class="text-white text-lg">
            <mat-label class="text-white">Description</mat-label>
            <input matInput name="description" formControlName="description" autocomplete="off">
          </mat-form-field>
          <mat-form-field appearance="outline" class="mt-0.5 w-full"
            *ngIf="filteredMessageTypes$ | async as messageTypes">
            <mat-label class="text-white">Message Type</mat-label>
            <mat-select class="text-white" name="messageTypeId" formControlName="messageTypeId">
              <mat-option *ngFor="let messageType of messageTypes | orderBy: ['description']" [value]="messageType.id">
                {{messageType.description}}</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="flex flex-row place-content-center items-center">
            <button class="bg-quorum-blue text-white disabled:opacity-50" mat-raised-button
              (click)="create(sourceTemplate, templateForm.value)" [disabled]="templateForm.invalid">
              Create
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>